import React from 'react';
import { withSSR } from 'react-i18next';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { FETCH_RELATED_SERVICES } from 'modules/related-services';
import { State } from 'store/types';
import '../../../../i18n.config';
import { BathroomRepairRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

const WithI18 = withSSR()(BathroomRepairRemote);

registerWidget<State, Record<string, string>>(`${__NAME__}/bathroom-repair`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);
  const {
    localization: { initialI18nStore, initialLanguage },
  } = state;
  store.dispatch(FETCH_RELATED_SERVICES.success, state.relatedServices?.serviceList ?? undefined);

  return remoteProps => (
    <WithI18
      initialI18nStore={initialI18nStore}
      initialLanguage={initialLanguage}
      router={router}
      store={store}
      {...remoteProps}
    />
  );
});
